import { RunsNavigation } from './RunsNavigation';
import { RunDetailsNavigation } from './RunDetailsNavigation';
import { CompareNavigation } from './CompareNavigation';

export const runsNavigation = new RunsNavigation(
  new RunDetailsNavigation('project.runs', 'd_'),
  new CompareNavigation('project.runs', 'c_'),
);
